import { render, staticRenderFns } from "./HsabInvestmentRedirectPage.vue?vue&type=template&id=23b1e41e&scoped=true"
import script from "./HsabInvestmentRedirectPage.vue?vue&type=script&lang=ts"
export * from "./HsabInvestmentRedirectPage.vue?vue&type=script&lang=ts"
import style0 from "./HsabInvestmentRedirectPage.vue?vue&type=style&index=0&id=23b1e41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1e41e",
  null
  
)

export default component.exports